
import { ButtonTypes, ButtonSizes, Wrapper } from './styles';

export default {
  name: 'Button',
  components: {
    Wrapper,
  },
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'md',
      validator(value: typeof ButtonSizes[number]) {
        return ButtonSizes.indexOf(value) !== -1;
      },
    },
    title: {
      type: String,
      default: 'Botão Legal',
    },
    type: {
      type: String,
      default: 'primary',
      validator(value: typeof ButtonTypes[number]) {
        return ButtonTypes.indexOf(value) !== -1;
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
